import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import './index.less';
import SideBarTool from "@/commons/components/side-bar-tool";
import { ReactComponent as LinkSvg } from '@/commons/icons/panel-icon/link.svg';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { addRoom, deleteRoom, getRooms, updateRoom } from '@/api/building/room';
import { RoomType } from '@/commons/enums/room-type';
import { Room, StoreyRoom } from '@/commons/interface/building/room';
import { Button, Form, Input, Modal, message } from 'antd';
import { ReactComponent as ConfimSvg } from '@/commons/icons/marshalling/confim.svg';
import { ReactComponent as EditSvg } from '@/commons/icons/marshalling/edit.svg';
import { ReactComponent as UpSvg } from '@/commons/icons/marshalling/up-arrow.svg';
import { ReactComponent as DownSvg } from '@/commons/icons/marshalling/down-arrow.svg';
import classNames from 'classnames';
import { graphicStore } from '@/commons/store/graphic-store';
import { AddPrimitivesCommand, ModelBase } from "pytha";
import { BIM_SINGAL, BimModelBase, GroupType } from 'tnbimbase';
import TnModal from '@/commons/widget/base-modal';
import { createPrimitiveMulti } from '@/api/geometry/primitive';
import { ROOM_STATUS } from '@/commons/enums/room-status';
import { ReactComponent as Select2Svg } from '@/commons/icons/operation-bar/select2.svg'
import ConfirmModal from '@/commons/widget/monix-modal';

const tempRoomData: { value: string, uuid: string }[] = [
    { value: "room_DE", uuid: "ddcb6d89-8fc7-47e1-b336-970ad3177463" },
    { value: "room_ny", uuid: "94656b85-5ab0-4f40-b75e-dc0a1df29a6c" },
    { value: "room_eu", uuid: "6a1dfbbd-c33a-483d-bc20-1805f16d56de" },
    { value: "room_Gn", uuid: "c5c90c11-ba63-4314-acd9-ec92ee100a75" },
    { value: "room_as", uuid: "4a0619a2-6b49-40a9-9f50-e100eafbce1c" },
    { value: "room_pz", uuid: "91f7407d-bd54-43e8-97fb-56acce51e0f8" },
    { value: "room_hn", uuid: "8a3aa322-ab7d-441c-a7a8-3443c3f84e78" },
    { value: "room_NI", uuid: "4bcaa3c8-49ee-4937-b478-4e55cc458f3a" },
    { value: "room_xA", uuid: "857222c9-f621-4fea-807c-6a107ce7eb5f" },
    { value: "room_Sg", uuid: "fc45ad60-43f3-4047-b6b3-3fbc762e571a" },
]


export default function RoomPanel() {

    const { projectUuid, modelUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [displayRooms, setDisplayRooms] = useState<StoreyRoom[]>([]);
    const [activeStoreyUuid, setActiveStoreyUuid] = useState<string>();
    const [activeRoom, setActiveRoom] = useState<Room>();
    const [editRoomUuid, setEditRoomUuid] = useState<string>('');
    const [editRoomName, setEditRoomName] = useState<string>('');
    const [showAddRoom, setShowAddRoom] = useState<boolean>(false);
    const [showBtnGroup, setShowBtnGroup] = useState<boolean>(false);
    const [modalOpen, setModalOpen] = useState<boolean>(false)

    const [form] = Form.useForm();

    useEffect(() => {
        if (!projectUuid || !modelUuid) return;
        getRooms(projectUuid, modelUuid, RoomType.NORMAL).then(res => {
            if (res.status === 200) {
                let displayRooms: StoreyRoom[] = res.data || [];
                displayRooms = displayRooms.map(item => {
                    item.expand = false;
                    return item;
                })
                setDisplayRooms(displayRooms);
            }
        })
    }, [projectUuid, modelUuid])


    useEffect(() => {
        const editor = graphicStore?.extraContext?.getCurrentViewEditor();
        if (!editor) return () => { }; // 确保useEffect始终返回一个清理函数

        if (!editor.listeners.getSignal(BIM_SINGAL.onPointCreated)) {
            editor.listeners.registerSignal(BIM_SINGAL.onPointCreated);
        }
        editor.listeners.getSignal(BIM_SINGAL.onPointCreated).add(handlePointCreated);

        return () => {
            const currentEditor = graphicStore?.extraContext?.getCurrentViewEditor();
            if (currentEditor) {
                editor.listeners.getSignal(BIM_SINGAL.onPointCreated).remove(handlePointCreated);
            }
        };
    }, [graphicStore?.extraContext?.getCurrentViewEditor(), activeRoom]);


    // 激活获取点坐标的控制器
    const handlePointClick = (storey: StoreyRoom, room: Room) => {
        setActiveRoom(room);
        setActiveStoreyUuid(storey.storeyUuid);
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (editor) {
            editor.listeners.signals.onOpeCommandActive.dispatch('POINTCOORDINATEPROVIDERCONTROL');
        }
    };


    // 点击绘图区，获取点坐标，更新数据库
    const handlePointCreated = (pointInfo) => {
        if (!pointInfo) return;
        if (!activeRoom) return;

        // 将点的位置从世界坐标转换为屏幕坐标
        // const editor = graphicStore.extraContext.getCurrentViewEditor();

        // // 手动自定义的控制器进行销毁
        // controlRef.current.dispose();
        // controlRef.current = null;

        // 更新数据库中的位置信息和状态
        const updatedData = {
            pointx: pointInfo.position.x,
            pointy: pointInfo.position.y,
            pointz: pointInfo.position.z,
            status: ROOM_STATUS.Obtained,
        };

        updateRoom(activeRoom.uuid, updatedData).then(res => {
            if (res.status === 200) {
                // getUpdates();
                message.success("更新房间坐标成功");
            }
        }).catch(err => {
            message.error("更新房间坐标失败");
        }).finally(() => {

        })

    }


    const onExpandClick = (item: StoreyRoom, idx) => {
        if (item?.rooms?.length === 0) {
            return;
        }
        item.expand = !item.expand;
        displayRooms[idx] = { ...item };
        setDisplayRooms([...displayRooms]);

    }

    // const onConfirmLink = (e: string) => {
    //     if (!(e?.length > 0)) return
    //     let entities: ModelBase[] = activeRoom?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
    //     let saveJsonList = []
    //     for (let i = 0; i < entities.length; i++) {
    //         // createPrimitive
    //         let data = { ...entities[i]?.extraData || {}, roomUuid: e }
    //         entities[i].extraData = data
    //         saveJsonList.push(entities[i].toJson())
    //     }
    //     createPrimitiveMulti(saveJsonList, { modelUuid: modelUuid, projectUuid: projectUuid }).catch((e) => {
    //         message.error("更新失败！")
    //     })
    // }

    // 点击绑定房间号
    const onClickLink = (room: Room) => {
        setActiveRoom(room);
        setModalOpen(true);
        // 手动设置表单的字段值，确保表单字段的值是最新的
        form.setFieldsValue({ roomNumber: room.roomNumber });
    }

    // 保存房间号的回调函数
    const onConfirmSave = () => {
        form.validateFields().then(values => {
            const updatedRoomNumber = values.roomNumber;
            if (!activeRoom) return;

            // 更新数据库中的房间号
            updateRoom(activeRoom.uuid, { roomNumber: updatedRoomNumber }).then(res => {
                if (res.status === 200) {
                    message.success("更新房间号成功");
                    // 更新前端显示的房间信息
                    let sIdx = displayRooms.findIndex(item => item.storeyUuid === activeStoreyUuid);
                    let rooms = displayRooms[sIdx].rooms;
                    let rIdx = rooms.findIndex(item => item.uuid === activeRoom.uuid);
                    rooms[rIdx].roomNumber = updatedRoomNumber;
                    setDisplayRooms([...displayRooms]);
                }
            }).catch(err => {
                message.error("更新房间号失败");
            }).finally(() => {
                setModalOpen(false);
                form.resetFields();
            });
        });
    };

    const onDeleteClick = () => {
        if (!activeRoom) {
            message.warning("没有选中房间");
            return;
        }
        TnModal().deleteModal({
            closable: false,
            onOk() {
                deleteRoom(projectUuid, activeRoom.uuid).then(res => {
                    message.success("删除成功");
                    // 1 去除属性
                    let sIdx = displayRooms.findIndex(item => item.storeyUuid === activeStoreyUuid);
                    let rooms: Room[] = displayRooms[sIdx].rooms;
                    let rIdx = rooms.findIndex(item => item.uuid === activeRoom.uuid);
                    let room = rooms[rIdx];
                    let priUuids = room?.primitiveUuids || [];
                    if (priUuids?.length > 0) {
                        let newEntities = [];
                        for (let uuid of priUuids) {
                            let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                            if (!(entity as BimModelBase).group[GroupType.ROOM]) {
                                continue;
                            }
                            let groupUuids = (entity as BimModelBase).group[GroupType.ROOM];
                            groupUuids = groupUuids?.filter(item => item !== activeRoom.uuid) || [];
                            (entity as BimModelBase).group[GroupType.ROOM] = groupUuids;
                            newEntities.push(entity);
                        }
                        new AddPrimitivesCommand(newEntities).execute();
                    }
                    // 2 修改列表
                    room.primitiveUuids = [];
                    rooms.splice(rIdx, 1);
                    setDisplayRooms([...displayRooms]);
                }).finally(() => {
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
        })
    }

    const onRoomClick = (item, sub) => {
        setActiveRoom(sub);
        setActiveStoreyUuid(item.storeyUuid);
        let entities: ModelBase[] = sub?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
        }
    }

    const onAddBtnClick = () => {
        if (!activeStoreyUuid) {
            message.warning("没有选中层");
            return;
        }
        setEditRoomName("");
        setEditRoomUuid("");
        let idx = displayRooms.findIndex(item => item.storeyUuid === activeStoreyUuid);
        displayRooms[idx].expand = true;
        setDisplayRooms([...displayRooms]);
        setShowAddRoom(true);
    }

    const onAddSave = () => {
        if (!projectUuid || !modelUuid) return;
        if (loading) return;
        if (!editRoomName) {
            setEditRoomName("");
            setShowAddRoom(false);
            return;
        }
        setLoading(true);
        let data: Room = {
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            name: editRoomName,
            storeyUuid: activeStoreyUuid,
            type: RoomType.NORMAL,
        }
        addRoom(projectUuid, modelUuid, data).then(res => {
            if (res.status === 200) {
                let uuid = res.data;
                message.success("添加成功");
                data.uuid = uuid;
                let idx = displayRooms?.findIndex(item => item.storeyUuid === activeStoreyUuid);
                displayRooms[idx].rooms.push(data);
                setDisplayRooms([...displayRooms]);
            }
        }).catch(() => {
            message.error("添加失败");
        }).finally(() => {
            setLoading(false);
            setShowAddRoom(false);
            setEditRoomName("");
            setEditRoomUuid("");
        })
    }

    const onRoomEditClick = (storey: StoreyRoom, room: Room) => {
        setEditRoomUuid(room.uuid);
        setEditRoomName(room.name);
        setActiveRoom(room);
        setActiveStoreyUuid(storey.storeyUuid);
        setShowBtnGroup(true);
        let entities: ModelBase[] = room?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(3);
        }
    }

    const onSave = () => {
        // 1.获取当前选中的图元
        let selectedList = graphicStore.extraContext.getCurrentViewEditor().selectControl.getSelectedEntityList();
        let newPriUuids: string[] = selectedList?.map(item => item.uuid) || [];
        let activeRoomUuids = new Set(activeRoom?.primitiveUuids || []);
        let newPriUuidsSet = new Set(newPriUuids);
        let addedUuids = newPriUuids.filter(uuid => !activeRoomUuids.has(uuid));
        let removedUuids = [...activeRoomUuids].filter(uuid => !newPriUuidsSet.has(uuid));

        // 2.传递参数回去
        let data: Room = {
            ...activeRoom,
            name: editRoomName,
        }
        // 3.修改api 同步修改图元属性
        updateRoom(activeRoom.uuid, data).then(res => {
            if (res.status === 200) {
                // 1 修改图元属性（旧的需要删除属性，新的需要新增属性）
                let newEntities = [];
                for (let uuid of addedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ROOM]) {
                        (entity as BimModelBase).group[GroupType.ROOM] = [];
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ROOM] || [];
                    groupUuids.push(activeRoom.uuid);
                    (entity as BimModelBase).group[GroupType.ROOM] = groupUuids;
                    newEntities.push(entity);
                }

                for (let uuid of removedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ROOM]) {
                        continue;
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ROOM];
                    groupUuids = groupUuids?.filter(item => item !== activeRoom.uuid) || [];
                    (entity as BimModelBase).group[GroupType.ROOM] = groupUuids;
                    newEntities.push(entity);
                }
                new AddPrimitivesCommand(newEntities).execute();
                // 2 修改列表
                let sIdx = displayRooms.findIndex(item => item.storeyUuid === activeStoreyUuid);
                let rooms = displayRooms[sIdx].rooms;
                let rIdx = rooms.findIndex(item => item.uuid === activeRoom.uuid);
                rooms[rIdx].primitiveUuids = newPriUuids;
                rooms[rIdx].name = editRoomName;
                setDisplayRooms([...displayRooms]);
                message.success("编辑成功");

            }
        }).catch(err => {
            console.log('err', err)
            message.error("编辑失败");
        }).finally(() => {
            onCancel();
        })
    }

    const onCancel = () => {
        setEditRoomName("");
        setEditRoomUuid("");
        setShowBtnGroup(false);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(1);
    }

    return (
        <div className='room-container'>
            <SideBarTool
                activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                onDeleteBtnClick={onDeleteClick}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="room-side-title">房间</div>
            <div className='room-content-area'>
                <div className='room-content'>
                    {displayRooms?.map((item, key) => (
                        <>
                            <div
                                key={key}
                                className={classNames({
                                    'room-row': true,
                                    'room-row-active': activeStoreyUuid === item.storeyUuid,
                                })}
                                onClick={() => setActiveStoreyUuid(item.storeyUuid)}>
                                <div className='text-area'>{item.storeyName}</div>
                                <div
                                    className='icon-area'
                                    onClick={() => onExpandClick(item, key)}
                                >
                                    {item?.rooms?.length > 0 && item?.expand && <UpSvg />}
                                    {item?.rooms?.length > 0 && !item?.expand && <DownSvg />}
                                </div>
                            </div>
                            {item?.rooms?.length > 0 && item?.expand && item?.rooms?.map((sub, idx) => (
                                <div
                                    key={idx}
                                    className={classNames({
                                        'room-sub-row': true,
                                        'room-sub-row-active': activeRoom?.uuid === sub?.uuid,
                                    })}
                                    onClick={() => { onRoomClick(item, sub) }}>
                                    <div className='text-area'>
                                        {/* {sub?.name} */}
                                        {editRoomUuid !== sub.uuid && `${sub?.name}`}
                                        {editRoomUuid === sub.uuid && <Input
                                            value={editRoomName}
                                            onChange={(e) => setEditRoomName(e.target.value)}
                                            onPressEnter={onSave}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    setShowAddRoom(false);
                                                    setEditRoomName("");
                                                    setEditRoomUuid("");
                                                    setShowBtnGroup(false);
                                                    graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
                                                }
                                            }}
                                            placeholder='单击输入房间名称'
                                            autoFocus
                                        />}
                                    </div>
                                    {editRoomUuid !== sub.uuid && (
                                        <div className='icon-list'>
                                            <EditSvg className='icon-area' onClick={() => onRoomEditClick(item, sub)} />
                                            <LinkSvg className='icon-area' onClick={() => { onClickLink(sub) }} />
                                            <Select2Svg className='icon-area' onClick={() => handlePointClick(item, sub)} />
                                        </div>
                                    )}
                                    {editRoomUuid === sub.uuid && <div
                                        className='icon-area'
                                        onClick={() => onRoomEditClick(item, sub)}
                                    >
                                        <ConfimSvg />
                                    </div>}
                                </div>
                            ))}
                            {showAddRoom && activeStoreyUuid === item?.storeyUuid && (
                                <div className={classNames({
                                    'room-sub-row': true,
                                    'room-sub-row-active': true,
                                })}>
                                    <div className='text-area'>
                                        <Input
                                            value={editRoomName}
                                            onChange={(e) => setEditRoomName(e.target.value)}
                                            onPressEnter={onAddSave}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    setShowAddRoom(false);
                                                    setEditRoomName("");
                                                    setEditRoomUuid("");
                                                }
                                            }}
                                            placeholder='单击输入房间名称'
                                            autoFocus
                                        />
                                    </div>
                                    <div className='icon-area' onClick={onAddSave}><ConfimSvg /></div>
                                </div>
                            )}
                        </>
                    ))}
                </div>
            </div>
            {showBtnGroup && <div className='room-btn-group'>
                <div className="btn save" onClick={onSave}>确定</div>
                <div className="btn cancel" onClick={onCancel}>取消</div>
            </div>}
            {/* <RoomNumberModal onConfirmClick={(e) => { onConfirmLink(e) }} data={tempRoomData} isOpen={modalOpen} setIsOpen={setModalOpen} /> */}
            <ConfirmModal
                title={"绑定房间号"}
                visible={modalOpen}
                setVisible={setModalOpen}
                onSaveClick={onConfirmSave}
                wrapClassName="create-project-modal"
                saveDisable={loading}
            >
                <div className="create-project-body">
                    <Form
                        colon={false}
                        form={form}
                        autoComplete="off"
                        labelCol={{ span: 5 }}
                    >
                        <Form.Item label="房间号:" name="roomNumber" rules={[{ required: true, message: '房间号不能为空' }]} >
                            <Input type="number" autoFocus />
                        </Form.Item>
                        <Button loading={loading} htmlType="submit" style={{ display: 'none' }}></Button>
                    </Form>
                </div>
            </ConfirmModal>
        </div>
    )
}